import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import axios from 'axios';
import MainProfileActions from 'components/main';
import React, { useEffect } from 'react';
import { rpmEventTrackingServiceInstance } from 'services/rpm/rpm-track-event-service';
import { debug } from 'utils/helpers';
import { TRPMEvent } from '../rpm.types';
import { dateFormatWithTime } from '../util';

const EventList = ({ memberUuid }: { memberUuid: string }) => {
  const [events, setEvents] = React.useState<TRPMEvent | null>();
  const [page, setPage] = React.useState(0);
  const [totalRows, setTotalRows] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const fetchEvents = async (limit: number, offset: number) => {
    try {
      const response = await rpmEventTrackingServiceInstance.getRPMEvents(
        memberUuid,
        limit,
        offset
      );

      if (response?.data) {
        const sortedData = response.data.sort((a, b) => {
          return new Date(b.time).getTime() - new Date(a.time).getTime();
        });

        setEvents({
          data: sortedData,
          total: response.total,
        });

        setTotalRows(response.total);
      }
    } catch (err) {
      if (!axios.isCancel(err)) {
        debug(err as string);
      }
    }
  };

  const LoadDataEvents = () => {
    const source = axios.CancelToken.source();
    fetchEvents(rowsPerPage, page);

    return () => {
      source.cancel();
    };
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    LoadDataEvents();
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    LoadDataEvents();
  }, []);

  return (
    <div>
      <MainProfileActions />
      {(events === undefined || events === null) && <h5>Loading...</h5>}
      {events?.data.length === 0 && <h5>No events</h5>}

      {events && (
        <>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Provider uuid</TableCell>
                  <TableCell>Event Type</TableCell>
                  <TableCell>Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {events?.data.map((event) => {
                  return (
                    <TableRow
                      key={`e-${event.eventType}-${event.providerUuid}-${event.time}`}
                      component='tr'>
                      <TableCell>{event.providerUuid}</TableCell>
                      <TableCell>{event.eventType}</TableCell>
                      <TableCell>{event.time ? dateFormatWithTime(event.time) : ''}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[15, 25, 100]}
            component='div'
            count={totalRows}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </div>
  );
};

export default EventList;
